/* Dreamura · caderno grátis → Klaviyo (lista UrJVcV, flow "Caderno grátis — Popup homepage").
   Se o Klaviyo falhar, o formulário segue pelo envio normal do Shopify (cliente com tags). */
(function () {
  /* Uma só oferta nas páginas B2C: esconde o popup de saída do Shopify Forms ("Antes de ir embora… guia"). */
  try { var st = document.createElement('style'); st.textContent = 'shopify-forms-embed{display:none!important}'; document.head.appendChild(st); } catch (x) {}
  var KL_COMPANY = 'YuzbgE', KL_LIST = 'UrJVcV';
  var KEYS = ['sleepmaxxing', 'futari', 'omotenashi', 'bihada'];
  function lang() {
    var l = (document.documentElement.lang || 'pt').slice(0, 2).toLowerCase();
    return (l === 'en' || l === 'es') ? l : 'pt';
  }
  function caderno(form) {
    var r = form.querySelector('input[name="contact[tags]"]:checked');
    var v = r ? r.value : '';
    for (var i = 0; i < KEYS.length; i++) if (v.indexOf('caderno-' + KEYS[i]) > -1) return KEYS[i];
    return 'sleepmaxxing';
  }
  /* Captura antes de qualquer outro script (o captcha do Shopify também envia o formulário). */
  function bind() {
    if (window.__dmKlBound) return;
    window.__dmKlBound = true;
    window.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || (form.id !== 'dm-gate-form' && form.id !== 'dm-caderno-form')) return;
      var em = form.querySelector('input[type=email]');
      if (!em || !em.value || !window.fetch) return; // envio normal
      e.preventDefault();
      e.stopImmediatePropagation();
      if (form.dataset.dmSending) return;
      form.dataset.dmSending = '1';
      var btn = form.querySelector('[type=submit]');
      if (btn) btn.disabled = true;
      var origem = form.id === 'dm-gate-form' ? 'popup-home' : 'rodape';
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Caderno grátis — ' + origem,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: em.value.trim(),
                  properties: { caderno: caderno(form), idioma: lang(), origem_registo: origem }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: KL_LIST } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (!res.ok) throw res;
        try { localStorage.setItem('dm_gate_v1', 'subscribed'); } catch (x) {}
        document.dispatchEvent(new CustomEvent('dm:caderno-ok', { detail: { form: form } }));
        if (form.id !== 'dm-gate-form') {
          var ok = form.querySelector('[data-dm-ok]');
          var p = document.createElement('p');
          p.className = 'dm-offer__ok';
          p.setAttribute('tabindex', '-1');
          p.textContent = ok ? ok.textContent : 'Obrigado!';
          form.innerHTML = '';
          form.appendChild(p);
          p.focus();
        }
      }).catch(function () {
        if (btn) btn.disabled = false;
        HTMLFormElement.prototype.submit.call(form); // fallback: Shopify
      });
    }, true);
  }
  bind();
})();
